export default {
    indexOccurrenceSheets:          { method: 'get',    url: 'occurrence_sheets'},
    storeOccurrenceSheet:           { method: 'post',   url: 'occurrence_sheets' },
    updateOccurrenceSheet:          { method: 'put',    url: 'occurrence_sheets/{id}'},
    destroyOccurrenceSheet:         { method: 'delete', url: 'occurrence_sheets/{id}'},
    indexOccurrenceSheetStatus:     { method: 'get',    url: 'occurrence_sheets/status'},
    indexOccurrenceSheetTypes:      { method: 'get',    url: 'occurrence_sheets/types'},
    indexOccurrenceSheetAbsences:   { method: 'get',    url: 'occurrence_sheets/absences'},
    storeOccurrenceSheetAll:        { method: 'post',   url: 'occurrence_sheets/all' },
    storeOccurrenceApprovals:       { method: 'post',   url: 'occurrence_sheets/all' },
    storeOccurrenceSheetApproval:   { method: 'post',   url: 'occurrence_sheets/approval' },
    signOccurrenceSheet:            { method: 'post',   url: 'occurrence_sheets/{id}/document-sign' },
    cancelSignatureOccurrenceSheet: { method: 'post',   url: 'occurrence_sheets/{id}/cancel-signature' },
    signatureHistoryOccurrenceSheet:{ method: 'get',    url: 'occurrence_sheets/{id}/signature-history' },
    indexOccurrenceSheetProcesses:  { method: 'get',    url: 'occurrence_sheet_processes'}
}